"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var NavItem_1 = require("./components/NavItem");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var Pages_1 = require("@/rendering/common/Pages");
var about_us_menu_1 = require("./components/about-us-menu");
var information_menu_1 = require("./components/information-menu");
var featured_menu_1 = require("./components/featured-menu");
var submenu_mobile_1 = require("./components/submenu-mobile");
var WindowApi_1 = require("@/api/browser/WindowApi");
var mapStateToProps = function (state, ownProps) {
    var _a;
    return (__assign(__assign({}, state.layout), { userName: state.user.firstname ? state.user.firstname : state.user.email, userId: state.user.id || "", userFrom: state.user.from || "", userEmail: state.user.email || "", isNotConfirmed: !state.user.isConfirmed, hideAlert: state.page === Pages_1.Pages.CONFIRM_EMAIL_REGISTER ? true : false, showFav: state.page === Pages_1.Pages.SEARCH, page: state.page, lang: state.layout.language.languages
            .filter(function (it) { return it.id === state.layout.language.current; })[0]
            .code1.toLowerCase(), langShort: state.layout.language.languages
            .filter(function (it) { return it.id !== state.layout.language.current; })[0]
            .shortName.toUpperCase(), currencyShort: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, t: state.translate, hideSettings: ownProps ? ownProps.hideSettings : false, tel: state.layout.offices[0].telephone, nobottom: ownProps && ownProps.nobottom ? ownProps.nobottom : false, nosearch: ownProps && ownProps.nosearch ? ownProps.nosearch : false, isMobile: state.mobile || false, mobileMd: state.mobileMd || false, linkCareers: state.layout.careerUrl, pendingDocumentCount: state.user.id && state.side
            ? (_a = state.side.items
                .find(function (it) {
                return it.children &&
                    it.children.find(function (it2) { return it2.page === Pages_1.Pages.PENDING_DOCUMENT; });
            })) === null || _a === void 0 ? void 0 : _a.children.find(function (it) { return it.page === Pages_1.Pages.PENDING_DOCUMENT; }).count : 0, submenuAlign: ownProps && ownProps.submenuAlign ? ownProps.submenuAlign : "left" }));
};
var mapDispatchToProps = function (dispatch) { return ({
    onMegaMenuLeave: function () { return dispatch(MegaMenuAction_1.default.setAllPopupsActive(false)); },
    onBuySelected: function () { return dispatch(MegaMenuAction_1.default.setBuyPopupActive(true)); },
    onBuyHover: function () { return dispatch(MegaMenuAction_1.default.onBuyHover()); },
    onBuyToggle: function () { return dispatch(MegaMenuAction_1.default.onBuyToggle()); },
    onRentSelected: function () { return dispatch(MegaMenuAction_1.default.setRentPopupActive(true)); },
    onRentHover: function () { return dispatch(MegaMenuAction_1.default.onRentHover()); },
    onRentToggle: function () { return dispatch(MegaMenuAction_1.default.onRentToggle()); },
    onAgentSelected: function () { return dispatch(MegaMenuAction_1.default.setAgentPopupActive(true)); },
    onAgentHover: function () { return dispatch(MegaMenuAction_1.default.onAgentHover()); },
    onAgentToggle: function () { return dispatch(MegaMenuAction_1.default.onAgentToggle()); },
    onResourcesSelected: function () {
        return dispatch(MegaMenuAction_1.default.setResourcesPopupActive(true));
    },
    onResourcesHover: function () { return dispatch(MegaMenuAction_1.default.onResourcesHover()); },
    onResourcesToggle: function () { return dispatch(MegaMenuAction_1.default.onResourcesToggle()); },
    onAboutUsSelected: function () { return dispatch(MegaMenuAction_1.default.setAboutUsPopupActive(true)); },
    onAboutUsHover: function () { return dispatch(MegaMenuAction_1.default.onAboutUsHover()); },
    onAboutUsToggle: function () { return dispatch(MegaMenuAction_1.default.onAboutUsToggle()); },
    onLanguageEnter: function () { return dispatch(MegaMenuAction_1.default.onLanguageEnter()); },
    onLanguageToggle: function () { return dispatch(MegaMenuAction_1.default.onLanguageToggle()); },
    onMobileTopMenuClick: function () { return dispatch(MegaMenuAction_1.default.onMobileTopMenuClick()); },
    onMobileBack: function () { return dispatch(MegaMenuAction_1.default.onMobileBack()); },
    onMobileResourceBack: function () { return dispatch(MegaMenuAction_1.default.onMobileResourceBack()); },
    onAccountMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onAccountMenuToggle()); },
    onFavoriteMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onFavoriteMenuToggle()); },
    onMobileLangToggle: function () { return dispatch(MegaMenuAction_1.default.onMobileLangToggle()); },
    onBuyPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularDistrictToggle());
    },
    onBuyPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularBuildingToggle());
    },
    onRentPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularDistrictToggle());
    },
    onRentPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularBuildingToggle());
    },
    onLoginClicked: function () { return dispatch(MegaMenuAction_1.default.onLoginClicked()); },
    onLogoutClicked: function () { return dispatch(MegaMenuAction_1.default.onLogoutClicked()); },
    onMyAccountClick: function () { return dispatch(MegaMenuAction_1.default.onMyAccountClick()); },
    onFavoriteClick: function () { return dispatch(MegaMenuAction_1.default.onFavoriteClick()); },
    onSetLanguage: function (language) {
        return dispatch(LayoutAction_1.default.onSetLanguage(language));
    },
    onSearchIconClick: function () { return dispatch(MegaMenuAction_1.default.onSearchIconClick()); },
    onCallClick: function () { return dispatch(MegaMenuAction_1.default.onCallClick()); },
    onEmailClick: function () { return dispatch(MegaMenuAction_1.default.onEmailClick()); },
    onResourceForSaleClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForSaleClicked());
    },
    onResourceForRentClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForRentClicked());
    },
    onMobileResourcePopularDistrictsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularDistrictsClicked());
    },
    onMobileResourcePopularBuildingsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularBuildingsClicked());
    },
    onMobileResourceForSaleClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForSaleClick());
    },
    onMobileResourceForRentClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForRentClick());
    },
}); };
var MegaMenuV2Component = function (props) {
    // Use the `isMobile` flag supplied by the Redux store (updated via saga)
    var isMobile = props.mobileMd;
    var _a = react_1.useState(null), activeTab = _a[0], setActiveTab = _a[1];
    var _b = react_1.useState(false), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    var hoverTimeoutRef = react_1.useRef(null);
    var handleTabClick = function (tab, event) {
        // Clear any pending hover timeout
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        if (activeTab === tab) {
            setActiveTab(null);
            setIsMenuOpen(false);
        }
        else {
            setActiveTab(tab);
            setIsMenuOpen(true);
        }
    };
    var handleTabHover = function (tab, event) {
        // Clear any pending timeout
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        // Don't show submenu in mobile view
        if (isMobile) {
            return;
        }
        // Only show submenu for items that have one
        var item = menuItems.find(function (item) { return item.id === tab; });
        if (item && item.submenu) {
            setActiveTab(tab);
            setIsMenuOpen(true);
        }
    };
    var handleMenuLeave = function () {
        if (isMobile) {
            return;
        }
        // Add a small delay before closing to prevent flickering
        hoverTimeoutRef.current = setTimeout(function () {
            setIsMenuOpen(false);
            setActiveTab(null);
        }, 150);
    };
    var handleMenuEnter = function () {
        if (isMobile) {
            return;
        }
        // Clear the timeout if user re-enters the menu area
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    };
    // Cleanup timeout on unmount
    react_1.useEffect(function () {
        return function () {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
            }
        };
    }, []);
    // Menu items – typed with MenuItem so `submenu` is recognised as optional
    var menuItems = [
        {
            id: "buy",
            label: props.tMegamenu.buy,
            href: "/" + props.lang + "/property-search/buy",
        },
        {
            id: "rent",
            label: props.tMegamenu.rent,
            href: "/" + props.lang + "/property-search/rent",
        },
        {
            id: "featured",
            label: props.tMegamenu.featured,
            submenu: {
                align: "left",
                content: React.createElement(featured_menu_1.default, __assign({}, props)),
            },
            transform: "translateX(-15%)",
        },
        {
            id: "exclusive",
            label: props.tMegamenu.ourExclusive,
            href: "/" + props.lang + "/exclusives",
        },
        {
            id: "new-development",
            label: props.tMegamenu.newDevelopments,
            href: "/" + props.lang + "/firsthand-developments",
        },
        {
            id: "international",
            label: props.tMegamenu.international,
            href: "/" + props.lang + "/international/sudara-residences",
        },
        {
            id: "list",
            label: props.tMegamenu.list,
            href: "/" + props.lang + "/list-property",
        },
        {
            id: "information",
            label: props.tMegamenu.information,
            submenu: {
                align: "right",
                content: React.createElement(information_menu_1.default, __assign({}, props)),
            },
        },
        {
            id: "about-us",
            label: props.tMegamenu.aboutUs,
            submenu: {
                align: "right",
                content: React.createElement(about_us_menu_1.default, __assign({}, props)),
            },
        },
    ];
    var closeMenu = function () {
        setIsMenuOpen(false);
        setActiveTab(null);
    };
    // Close the menu automatically if we transition from mobile -> desktop
    react_1.useEffect(function () {
        if (!isMobile) {
            closeMenu();
        }
    }, [isMobile]);
    return (React.createElement(React.Fragment, null, isMobile && isMenuOpen ? (React.createElement(submenu_mobile_1.SubmenuMobile, __assign({}, props, { activeTab: activeTab }, menuItems.find(function (item) { return item.id === activeTab; }), { closeMenu: closeMenu }))) : (React.createElement("div", { className: "l-mega-v2", onMouseLeave: handleMenuLeave },
        React.createElement("nav", { className: "l-mega-v2__nav", onMouseEnter: handleMenuEnter }, menuItems.map(function (item) {
            var _a;
            return (React.createElement(NavItem_1.default, { key: item.id + "-" + isMobile, id: item.id, label: item.label, href: WindowApi_1.toAbsoluteUrl(item.href), isActive: activeTab === item.id, isMobile: isMobile, submenu: item.submenu, transform: item.transform, onClick: function (e) {
                    return handleTabClick(item.id, e);
                }, onMouseEnter: function (e) {
                    return handleTabHover(item.id, e);
                } }, (_a = item.submenu) === null || _a === void 0 ? void 0 : _a.content));
        }))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MegaMenuV2Component);
